// extracted by mini-css-extract-plugin
export default {"taskModal":"CreateTaskModal_taskModal__VcLoM","datePicker":"CreateTaskModal_datePicker__Xm-n0","typeDescription":"CreateTaskModal_typeDescription__CzWNW"};